import React, { useState } from 'react';
import { DataGrid, GridColDef, GridToolbarContainer } from '@mui/x-data-grid';
import { Button, Grid, Tooltip, Fade, ListItemIcon, Menu, MenuItem, InputBase, InputAdornment, IconButton } from "@mui/material";

const TablePaginate = (
  { rowsInfo,
    columns,
    Mostrar,
    loading
  }:
    {
      rowsInfo: any[],
      columns: GridColDef[],
      Mostrar: boolean,
      loading: boolean
    }) => {
  const [pageSize, setPageSize] = useState(25);
  const customLocaleText = {
    noRowsLabel: 'No se encontraron resultados',
    noResultsOverlayLabel: 'Resultados no encontrados',
    MuiTablePagination: {
      labelDisplayedRows: ({ from, to, count }: { from: any, to: any, count: any }) =>
        `${from} - ${to} de ${count}`,
      getItemAriaLabel: (type: any) => {
        if (type === 'first') {
          return 'Primera página';
        }
        if (type === 'last') {
          return 'Última página';
        }
        if (type === 'next') {
          return 'Página siguiente';
        }
        // if (type === 'previous') {
        return 'Página anterior';
      },
      labelRowsPerPage: 'Registros:',
      toolbar: {
        searchTooltip: 'Buscar…',
      },
    },
    footerRowSelected: (count: any) =>
      count > 1
        ? `${count.toLocaleString()} filas seleccionadas`
        : `${count.toLocaleString()} fila seleccionada`,
  };
  const ids = Array.isArray(rowsInfo)
    ? rowsInfo.map((r, i) => r?.OrdenSFTGNL ?? r?.uuid ?? r?.id ?? `idx-${i}`)
    : [];
  return (
    <>
      <Grid item xs={12}>
        <Grid style={{ height: 700, width: '100%' }}>
          <DataGrid
            rows={Array.isArray(rowsInfo) ? rowsInfo : []}
            columns={columns}
            getRowId={(row) => row?.OrdenSFTGNL || row?.uuid || row?.id || "defaultId"}
            loading={loading}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[25, 50, 100]}
            disableColumnMenu
            disableSelectionOnClick
            localeText={customLocaleText}
          />
        </Grid>
        <br />
        <Tooltip title="Asignar enlaces">
          <Button
            color="primary"
            variant="contained"
            style={{
              position: 'absolute',
              //bottom: '50px', // Ajusta la distancia desde la parte inferior
              right: '50px',  // Ajusta la distancia desde la derecha
              display: Mostrar ? 'block' : 'none', // Usar 'block' para mostrar y 'none' para ocultar
              textTransform: 'capitalize'
            }}
            onClick={() => {
              // Tu función onClick aquí
            }}
          >
            Asignar
          </Button>
        </Tooltip>
        <br />
      </Grid>

    </>
  );
};

export { TablePaginate };